

$(function () {
  $(".this-product-section .section-title").click(function () {
    $(".this-product-section .items").slideToggle();
    $(".this-product-section .section-title").toggleClass("active");
  });
});
$(function () {
  $(".our-team-section .section-title").click(function () {
    $(".our-team-section .items").slideToggle();
    $(".our-team-section .section-title").toggleClass("active");
  });
});


var doit;
window.onresize = function () {
  clearTimeout(doit);
  doit = setTimeout(function () {
    var width = $(window).width();
    $(window).resize(function () {
      if (width >= 768) {
        document.getElementsById("items").style.display = 'block';
      }
    });
  }, 100);
};
// if ( window.innerWidth > 700 ) {
//     document.querySelector(".our-team-section .section-title").classList.add('active');
//     document.querySelector(".this-product-section .section-title").classList.remove('active');
// }
// $(document).ready(function () {
//     $(window).scroll(function () {
//         if ($(this).scrollTop() > 10) {
//             $('.what-makes .section-title').addClass('active');

//         }
//         else {
//             $('.what-makes .section-title').removeClass('active');
//         }
//     });
//     var width = $(window).width();
//     $(window).resize(function () {
//         if (width >= 768) {
//             $('.what-makes .section-title').addClass('active');
//         }
//     });
// })

//FAQ product
$(function () {
  $('.product_accordions .accordions-description .tablink:first').addClass('active');
})
function openTab(tabName) {
  var i;
  var x = document.getElementsByClassName("description");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }
  document.getElementById(tabName).style.display = "block";
}
$(function () {
  $('.tabs .tablink').click(function () {
    $(this).addClass('active').siblings().removeClass('active');
  });
});

$(document).ready(function () {
  $('.template-product .product-row').each(function () {
    var $block = $(this);
    var $optionFilter = $block.find('.column-product-images');
    var $innerContent = $block.find('.column-form-container');
    var headerHeight = $('header').height();
    var announcement = $('#shopify-section-announcement-bar').height();
    var breadcrumbs = $('.breadcrumbs').height();

    if ($(window).width() > 767) {
        var stickyNav = function () {
          var stickyNavTop = $innerContent.offset().top;
          var stickyNavBottom = $innerContent.offset().top + $innerContent.height();
          var scrollTop = $(window).scrollTop();

        stickyNav();

        $(window).scroll(stickyNav);
        $(window).resize(stickyNav);
      }
    }
  });

  $('#ProductPhoto .zoom').zoom({});
});

$('.zoom-image-container').mouseleave(function () {
  $(this).find('.zoom-switch').removeClass('disable');
});

function zoomzoom(divclick, zoom, zoomimg, zmzm) {
  $(divclick).addClass('disable');
  //$(zoom).zoom();
  let tt = $(zoomimg).clone(); t = zoomimg, e = zmzm, s = t.clientWidth, o = t.clientHeight;
  mm = $('<div>' + t.outerHTML + "</div>");
  $(t).replaceWith(mm); let i = mm,
    n = mm.find('img'); i.css("width", s + "px"), i.css("height", o + "px"), i.mousemove(function (t) { let e = $(this).offset(), i = (t.pageX - e.left) / s * 100 <= 100 ? (t.pageX - e.left) / s * 100 : 100, c = (t.pageY - e.top) / o * 100 <= 100 ? (t.pageY - e.top) / o * 100 : 100; n.css("transform-origin", i + "% " + c + "%") }), i.mouseenter(function () { n.css("cursor", "crosshair"), n.css("width", s + "px"), n.css("height", o + "px"), n.css("transition", "0.2s"), n.css("transform", "scale(" + e + ")") }).mouseleave(function () { n.css("transition", "0.2s"), n.css("transform", "scale(1)"), $(divclick).removeClass('disable'); })
};